import { bindingTypes } from '@adalo/constants'

import { evaluateCondition } from './conditions'
import { evaluateBinding, getBindingValue } from './dependencies'

export const getVisible = (state, object, opts) => {
  let { visibility } = object.attributes

  let binding = visibility

  if (
    !visibility ||
    !visibility.source ||
    visibility.bindingType !== bindingTypes.VISIBILITY
  ) {
    return true
  }

  let bindingData = evaluateBinding(state, visibility, opts)

  let comparison = getBindingValue(visibility.comparison, { ...opts, state })
  let comparison2 = getBindingValue(visibility.comparison2, { ...opts, state })

  return evaluateCondition(
    bindingData,
    binding.comparator,
    binding.source.dataType,
    comparison,
    comparison2
  )
}
